import styled, { css } from 'styled-components';

type Props = {
  status: boolean;
  disabled?: boolean;
  onChange: (status: boolean) => void;
  size?: number;
};

const ToggleRadio = (props: Props) => {
  return (
    <Style
      status={props.status}
      onClick={(e) => {
        e.stopPropagation();
        !props.disabled && props.onChange(!props.status);
      }}
      disabled={props.disabled}
      style={{ fontSize: props.size || 1 }}
    >
      <CircleStyle status={props.status}>
        <div className="circle" />
      </CircleStyle>
    </Style>
  );
};

type StyleProps = { status: boolean; disabled?: boolean };

const Style = styled.div<StyleProps>`
  font-size: 1px;
  width: 28em;
  height: 16em;
  position: relative;
  transition: background-color 0.3s;
  background-color: ${({ status, theme }) =>
    status ? theme.colors.primary100 : theme.colors.gray300};
  border-radius: 10em;
  cursor: pointer;
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;

const CircleStyle = styled.div<{ status: boolean }>`
  position: absolute;
  padding: 2em;
  transition: transform 0.3s;
  transform: translateX(${({ status }) => (status ? 12 : 0)}em);
  .circle {
    width: 12em;
    height: 12em;
    border-radius: 6em;
    background-color: ${(props) => props.theme.colors.gray100};
    box-shadow: 1em 1em 4em ${(props) => props.theme.colors.ND20};
  }
`;

export default ToggleRadio;
